// Module
var code = "<div class=\"editor flex-column\"> <canvas id=\"editor\"></canvas> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/wbs/directives/wbs_editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;